import * as ActionTypes from '../../constants/ActionTypes';
import API from '../../helpers/api';

export function getApplicationStatus(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_APPLICATION_STATUS_REQUEST,
			payload: { loading: true }
		});

		const response = await API.application_status.getApplicationStatus(id);

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_APPLICATION_STATUS_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { application } = response.data;

		dispatch({
			type: ActionTypes.GET_APPLICATION_STATUS_SUCCESS,
			payload: {
				application,
				loading: false
			}
		});
	};
}

export function onApplicationStatusSubmit({ id, fields }) {
	return async (dispatch, getState) => {
		const { application } = getState().applicationPage.applicationStatusPageReducer;
		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_STATUS_REQUEST,
			payload: { loadingSubmit: true }
		});

		const body = {
			application: {
				...fields
			}
		};

		if(application){
			body.application.updated_at = application.updated_at;
		}

		const response = await API.application_status.updateApplicationStatus(id, body);

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_APPLICATION_STATUS_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});
			return;
		}

		const { application: newApplication } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_STATUS_SUCCESS,
			payload: {
				application: newApplication,
				loadingSubmit: false,
				meta: response.meta
			}
		});
	};
}

export function sendPassportForReview(fields) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_PASSPORT_REQUEST,
			payload: { loadingPassportSubmit: true }
		});

		const body = {
			application: {
				...fields
			}
		};

		const response = await API.application_status.sendPassportForReview(body);

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_APPLICATION_PASSPORT_ERROR,
				payload: {
					meta: response.meta,
					loadingPassportSubmit: false
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_PASSPORT_SUCCESS,
			payload: {
				meta: response.meta,
				loadingPassportSubmit: false
			}
		});
	};
}

export function sendItineraryForReview(fields) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_ITINERARY_REQUEST,
			payload: { loadingItinerarySubmit: true }
		});

		const body = {
			application: {
				...fields
			}
		};

		const response = await API.application_status.sendItineraryForReview(body);

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_APPLICATION_ITINERARY_ERROR,
				payload: {
					meta: response.meta,
					loadingItinerarySubmit: false
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_ITINERARY_SUCCESS,
			payload: {
				meta: response.meta,
				loadingItinerarySubmit: false
			}
		});
	};
}

export function sendInsuranceForReview(fields) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_INSURANCE_REQUEST,
			payload: { loadingInsuranceSubmit: true }
		});

		const body = {
			application: {
				...fields
			}
		};

		const response = await API.application_status.sendInsuranceForReview(body);

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_APPLICATION_INSURANCE_ERROR,
				payload: {
					meta: response.meta,
					loadingInsuranceSubmit: false
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.SUBMIT_APPLICATION_INSURANCE_SUCCESS,
			payload: {
				meta: response.meta,
				loadingInsuranceSubmit: false
			}
		});
	};
}

export function resetApplicationStatusPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_APPLICATION_STATUS_PAGE
		});
	};
}

export function resetApplicationStatusMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_APPLICATION_STATUS_META
		});
	};
}